import React from 'react'
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
  } from "@mui/material";
import { MonthYearFilterProps } from '../../types/types';

const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const MonthYearFilter = (props: MonthYearFilterProps) => {
    const handleChangeMonth = (event: SelectChangeEvent) => {
        props.setMonth(event.target.value);
    };
    return (
        <div className="dates-monthrange">
            <FormControl>
                <InputLabel id="demo-simple-select-label">Month</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.month}
                label="Month"
                onChange={handleChangeMonth}
                >
                {months.map((monthName,index) => {
                    const monthNumber = index+1;
                    return <MenuItem value={monthNumber}>{monthName}</MenuItem> 
                })}
                </Select>
            </FormControl>
            <FormControl>
                <InputLabel id="demo-simple-select-label">Year</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.year}
                label="Year"
                onChange={props.handleChangeYear}
                >
                    {props.yearOptions.map((year) => {
                            return <MenuItem value={year}>{year}</MenuItem>
                    })}
                </Select>
            </FormControl>
            </div>
    )
}

export default MonthYearFilter